export default __webpack_public_path__ + "static/media/mokho.0d4e1dde.png";